// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container{background-color:#f1f8fd;padding:25px 0;height:100vh}.page-container .page-section:not(:first-child){width:100%;margin-top:10px}.page-container__iframe-close-button{position:absolute;top:15px;right:15px;z-index:10}.page-container .bp3-btn:hover{background-color:transparent}.page-container .bp3-btn:focus{outline:none}\n", ""]);
// Exports
module.exports = exports;
